<template>
  <div id="technology">
    <div class="page-header header-filter" data-parallax="true" style="background-image: url('static/img/AI-Talents.jpg'); height:50vh">
          <div class="container">
              <div class="row">
              <div class="col-md-8 ml-auto mr-auto">
                  <div class="brand text-center">
                  <h1 class="title">專業技術</h1>
                  <h3 class="title description">Technology is our cornerstone. Innovation is our passion.</h3>
                  </div>
              </div>
              </div>
          </div>
      </div>
      <div class="main main-raised">
          <div class="container">
            <div class="section text-center">
              
            </div>

            <div class="row align-items-center ">
              <div class="card">
                <div class="row">
                  <div class="col-lg-6 col-12">
                    <div class="card-header card-header-image">
                      <a href="#pablo">
                        <img class="img" src="/static/img/AI-Talents.jpg" />
                      </a>
                    </div>
                  </div>
                  <div class="col-lg-6 col-12">
                    <div class="card-body">
                      <h2 class="card-title"><a href="#">邏輯製程</a></h2>
                      <div class="description">
                        TSMC has always insisted on building a strong, in-house R&D capability. As a global semiconductor technology leader, TSMC provides the most advanced and comprehensive portfolio of dedicated foundry process technologies...
                      </div>
                      <a href="" class="learnMore">more <i class="material-icons">keyboard_arrow_right</i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="card">
                <div class="row">
                  <div class="col-lg-6 col-12">
                    <div class="card-header card-header-image">
                      <a href="#pablo">
                        <img class="img" src="/static/img/AI-Talents.jpg" />
                      </a>
                    </div>
                  </div>
                  <div class="col-lg-6 col-12 order-lg-first">
                    <div class="card-body">
                      <h2 class="card-title"><a href="#">特殊製程</a></h2>
                      <div class="description">
                        TSMC provides an industry-leading specialty technologies portfolio that complements its advanced technology leadership. The Company's comprehensive specialty technologies meet specific customer needs and...
                      </div>
                      <a href="" class="learnMore">more <i class="material-icons">keyboard_arrow_right</i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "technology",
  props: [],
  data() {
    return {
      
    };
  },
  methods: {},
  filters: {},
  computed: {},
  created() {},
  mounted() {
  },
  components: {},
  watch: {}
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/introduction/technology.vue